import { partners } from "../partners";

export const getPartner = (slug) =>
  partners.find((partner) => partner.slug === slug);
